/* AZ & CO — the sourcing request's two paths.

   Shopify's customer form will not submit without contact[email], and the
   address is the only field it stores as real customer data. But demanding
   an email to ask a question over WhatsApp is friction on the one action
   this shop most wants people to take.

   So the email is optional and the button reads the field:

     filled  - post to Shopify. A customer is created with marketing
               consent, and the number and bottle ride along in the
               notification.
     empty   - no post at all. WhatsApp opens with the bottle already
               written, which is the conversation they were going to have
               anyway.

   The alternative was minting an address from the phone number to satisfy
   the form. That fills Customers with undeliverable contacts and quietly
   ruins the sending reputation of the list it is meant to build, so it is
   not done here.

   Numbers are normalised for the wa.me link only: it wants bare digits with
   a country code, so 050..., 0050... and +971 50... all have to arrive at
   the same string. What the visitor typed is left untouched in the field. */
(function () {
  var form = document.querySelector('.srcq-form');
  if (!form) return;

  var wa = form.getAttribute('data-wa') || '';
  var bottle = form.querySelector('[name="contact[bottle]"]');
  var phone = form.querySelector('[name="contact[whatsapp]"]');
  var email = form.querySelector('[name="contact[email]"]');
  if (!bottle || !phone) return;

  /* UAE: strip everything that is not a digit, drop a trunk zero, and add
     the country code when it is missing. 00 971 ... arrives here as
     00971..., so the international prefix goes first. */
  function normalise(raw) {
    var d = String(raw || '').replace(/\D/g, '');
    if (!d) return '';
    if (d.slice(0, 2) === '00') d = d.slice(2);
    if (d.slice(0, 3) === '971') return d;
    if (d.charAt(0) === '0') d = d.slice(1);
    return '971' + d;
  }

  /* Light touch: only the characters a phone number can contain, so a
     mistyped letter is caught before the round trip. */
  phone.addEventListener('input', function () {
    var cleaned = phone.value.replace(/[^\d+\s()-]/g, '');
    if (cleaned !== phone.value) phone.value = cleaned;
    phone.setCustomValidity(normalise(phone.value).length >= 11 ? '' : ' ');
  });

  phone.addEventListener('blur', function () {
    var d = normalise(phone.value);
    if (d.length >= 11) phone.value = '+' + d.slice(0, 3) + ' ' + d.slice(3, 5) + ' ' + d.slice(5, 8) + ' ' + d.slice(8);
  });

  form.addEventListener('submit', function (e) {
    var hasEmail = email && email.value.trim() !== '';
    if (hasEmail) return;                 /* let Shopify take it */
    if (!form.checkValidity()) return;    /* let the browser report first */

    e.preventDefault();

    var msg = 'Hi AZ & CO, I am looking for: ' + bottle.value.trim() +
              '. My WhatsApp is +' + normalise(phone.value) + '.';

    window.open('https://wa.me/' + wa + '?text=' + encodeURIComponent(msg), '_blank', 'noopener');

    var done = form.getAttribute('data-sent');
    if (done) {
      var p = document.createElement('p');
      p.className = 'srcq-done';
      p.textContent = done;
      form.replaceChildren(p);
    }
  });
})();
